<template>
        <el-card class="box-card" style="width: 1300px;margin:80px auto 0;">
         <el-table
            :data="tableData"
            >
          
            <el-table-column
                prop="title"
                label="主题"
                >
            </el-table-column>
            <el-table-column
                prop="times"
                label="答题次数">
            </el-table-column>
            <!-- <el-table-column
               prop="username"
               label="答题者"
             > 
            </el-table-column> -->
            <el-table-column
                prop="score"
                label="得分">
            </el-table-column>
             <el-table-column
                prop="zscore"
                label="总分">
            </el-table-column>
              <el-table-column
                prop="inserttime"
                label="答题日期"
                >
            </el-table-column>
            <el-table-column>
                  <template slot-scope="scope">
                        <el-button type="primary" @click.native="goAnswerDetail(scope.$index,tableData)">查看回答详情</el-button>
                 </template>     
            </el-table-column>
            </el-table>
        </el-card>
</template>
   

<script>
export default {
      data() {
        return {
            tableData:[],
            id:"",
        }
      },
      methods:{
         
         init(){
                   this.$http.post("Exam/GetSearchList", {
                            action:"getuserexamlog",
                             id:this.id,
                            })
                            .then((res) => {
                                
                                if(res.data.isok){
                                    this.tableData = res.data.data
                                }
                            })
         },
         goAnswerDetail(index,tableData){
              this.$router.push({path:'/answerdetail',query:{id:tableData[index].examid,score:tableData[index].score}})
         }


      },
      created(){
          this.id = this.$route.query.id
         this.init()
      }
    }

</script>



// WEBPACK FOOTER //
// src/components/QueryScore.vue